import { ImagePaths } from '@/lib/utils';
import { LoaderCircle, TriangleAlert } from 'lucide-react';
import Image from 'next/image';
import { Button } from '../ui/button';

export const CustomerDataLoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-400px)] ">
      <LoaderCircle className="animate-spin mx-auto text-brand-primary" size={80} />
      <h4 className="text-gray-900 mt-10 font-medium text-lg">
        Fetching customer details and financial records. Please wait...
      </h4>
      <p className="text-gray-600 text-sm mt-1 text-center">
        We’ll inform you via email when the data import will be finished.
      </p>
    </div>
  );
};

export const LoginLoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-400px)]">
      <LoaderCircle className="animate-spin mx-auto text-brand-primary" size={80} />
      <h4 className="text-gray-900 mt-10">Redirecting to Login...</h4>
    </div>
  );
};

export const AccountingDisconnectedState = ({
  title,
  message,
  className = 'min-h-[calc(100vh-400px)]',
  btnProps,
}: {
  title: string;
  message: string;
  btnProps?: {
    action: string;
    callback?: () => void;
    loading?: boolean;
  };
  className?: string;
}) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <Image src={ImagePaths.EXCLAIM_ICON} width={84} height={76} alt="account-disconnected" className="w-21 h-19" />
      <h4 className="text-gray-900 mt-8 text-xl font-medium">{title}</h4>
      <p className="text-gray-600 text-lg mt-1 text-center mb-8">{message}</p>
      {btnProps?.action && (
        <Button className="brand-primary-button max-w-48!" onClick={btnProps?.callback} disabled={btnProps?.loading}>
          {btnProps?.loading ? <LoaderCircle className="animate-spin mx-auto" /> : btnProps?.action}
        </Button>
      )}
    </div>
  );
};

export const GenericUIState = ({ heading, desc, error }: { heading: string; desc: string; error: boolean }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-400px)]">
      {error ? (
        <TriangleAlert className="mx-auto text-red-400 my-5" size={200} />
      ) : (
        <Image
          src={ImagePaths.SUCCESSICON}
          alt="Successful"
          width={200}
          height={200}
          className="mx-auto my-5"
          loading="eager"
        />
      )}
      <h2 className="text-2xl font-medium text-black mb-3">{heading}</h2>
      <p className="font-normal text-brand-grey-600 mb-10">{desc}</p>
    </div>
  );
};

export const ApiLoadingState = ({ title, message }: { title: string; message: string }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/10 backdrop-blur-xs min-h-[calc(100vh-400px)] z-1000">
      <div className="max-w-sm md:max-w-xl px-8 py-12 rounded-xl text-primary shadow-lg bg-white">
        <div className="flex flex-col items-center justify-center">
          <LoaderCircle className="animate-spin mx-auto text-brand-primary mb-8" size={60} />

          <h4 className="text-gray-900 font-medium text-2xl mb-1">{title}</h4>

          <p className="text-gray-600 text-lg text-center">{message}</p>
        </div>
      </div>
    </div>
  );
};
